/**
 * @fileoverview Barra de progreso fina con texto "Afirmación X de N".
 */

/**
 * @param {{ actual: number, total: number, etiqueta?: string }} props
 */
export function ProgressBar({ actual, total, etiqueta }) {
    const safeTotal = Math.max(1, total);
    const pct = Math.min(100, Math.round(((actual + 1) / safeTotal) * 100));
    return (
        <div className="w-full" data-testid="progress-bar">
            <div className="flex justify-between text-xs text-muted-foreground mb-1.5 font-medium">
                <span>{etiqueta || `Afirmación ${Math.min(actual + 1, safeTotal)} de ${safeTotal}`}</span>
                <span>{pct}%</span>
            </div>
            <div
                role="progressbar"
                aria-valuemin={0}
                aria-valuemax={100}
                aria-valuenow={pct}
                className="w-full h-1.5 bg-secondary rounded-full overflow-hidden"
            >
                <div
                    className="h-full bg-primary transition-[width] duration-300 ease-out"
                    style={{ width: `${pct}%` }}
                />
            </div>
        </div>
    );
}
